// extracted by mini-css-extract-plugin
export default {"container":"social-scroll-ScrollArrow__container--1iZzF","arrow":"social-scroll-ScrollArrow__arrow--Olh02"};